import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import ResultState from './partials/result-state';
import service from '../../services/request-service';
import { useLoadingBar } from '../../libraries/contexts';
import { generalClasses as styles } from './styles';

const ResultView = props => {
  const {
    classes,
    match: {
      params: { id }
    }
  } = props;

  const [data, setData] = useState(null);
  const [, setLoading] = useLoadingBar();

  const getRequests = async () => {
    setLoading({ principalLoading: true });
    const data = await service.get(id);
    setData(data);
    setLoading({ principalLoading: false });
  };

  useEffect(() => {
    if (id) {
      getRequests();
    }
  }, []);
  return (
    <React.Fragment>
      {data ? (
        <div className={classes.cardColumn}>
          <ResultState {...props} data={data} />
        </div>
      ) : (
        ''
      )}
    </React.Fragment>
  );
};

ResultView.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ResultView);
